import React, { useEffect, useState } from "react";
import ModalComponents from "../modals/ModalComponents";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import DropDownElement from "../elements/DropDownElement";
import { useUserContext } from "../../context/UserContext";
import { useStoreContext } from "../../context/StoreContext";
import { useCreditorContext } from "../../context/CreditorContext";
import Menu from "./HamburgerMenu";
import {
  DashboardsArray,
  DefaultArray,
  linksArray,
} from "../hamburgerMenuList/ListsArrayMenu";

// type dataProps = {
//   title: string;
//   message: string;
//   date: string;
//   time: string;
//   created_at: string;
//   is_read: boolean;
//   notification_type:
//     | "NORMAL_NOTIFICATION"
//     | "SUCCESS_NOTIFICATION"
//     | "FAIL_NOTIFICATION";
//   notification_uid: string;
// };
interface YourComponentProps {
  enteredUser: string | null;
  setEnteredUser: React.Dispatch<React.SetStateAction<string | null>>;
}

const HeaderLandignUserPanel: React.FC<YourComponentProps> = ({
  enteredUser,
  setEnteredUser,
}) => {
  // const axiosHook = useAxiosInstance();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [isOpen, setIsOpen] = useState<boolean>(false);
  // const [setData] = useState<dataProps[]>([]);
  const { setUserData } = useUserContext();

  const { setStoreData } = useStoreContext();
  const { setCreditor } = useCreditorContext();

  // const toggleModal = () => {
  //   setIsModalOpen(!isModalOpen);

  //   const body = document.querySelector("body");
  //   if (body) {
  //     body.classList.toggle("overflow-hidden");
  //   }
  // };

  // const logedIn =
  //   localStorage.getItem("user_state") === "REGISTERED" ||
  //   localStorage.getItem("user_state") === "VERIFIED"
  //     ? localStorage.getItem("access_token")
  //     : null;

  // const openModal = () => {
  //   setIsLoginOpen(!isLoginOpen);
  //   setEnteredUser(logedIn);

  //   const body = document.querySelector("body");
  //   if (body) {
  //     body.classList.toggle("overflow-hidden");
  //   }
  // };

  const old_access_token = localStorage.getItem("old_access_token");

  const logOut = () => {
    Swal.fire({
      title: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#477CD1",
      cancelButtonColor: "white",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",
        icon: "no-border",
        title: "title-padding",
      },
    }).then((result) => {
      if (!old_access_token) {
        if (result.isConfirmed) {
          localStorage.clear();
          document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          });
          setUserData(null);
          setStoreData(null);
          setCreditor(null);
          setEnteredUser(null);
          Swal.fire({
            title: "از حساب کاربری خود خارج شدید",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/");
        }
      } else {
        old_access_token &&
          localStorage.setItem("access_token", old_access_token);

        localStorage.removeItem("old_access_token");
        navigate("/fa/admin-dashboard");
      }
    });
  };

  // const getNotifData = () => {
  //   setIsLoading(true);
  //   axiosHook
  //     .get(USER_LIST_NOTIFICATIONS(user_id, 1, 4, ""))
  //     .then((res) => {
  //       setIsLoading(false);
  //       setData(res.data.data.results);
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //     });
  // };

  useEffect(() => {
    setEnteredUser(
      localStorage.getItem("user_state") === "REGISTERED" ||
        localStorage.getItem("user_state") === "VERIFIED"
        ? localStorage.getItem("access_token")
        : null
    );
  }, [enteredUser, isModalOpen, isLoginOpen]);

  // const OpenNotifPage = () => {
  //   setIsOpen(true);
  //   getNotifData();
  // };

  return (
    <>
      <header className="h-[90px] flex items-center flex-1 justify-between">
        <div className="wrapper flex justify-between lg:justify-between items-center mx-auto max-w-[1190px]">
          <div className="lg:hidden z-[9999999999999] mr-2">
            <Menu
              linksArray={linksArray}
              DashboardsArray={DashboardsArray}
              DefaultArray={DefaultArray}
            />{" "}
          </div>

          <div className="hidden lg:block">
            <a href="/" className="flex items-center">
              <img
                src="/images/logovam30.png"
                className="sm:mr-3 mr-0 h-6 sm:h-9"
                alt="Flowbite Logo"
              />
            </a>
          </div>
          <div className="flex shrink lg:order-2">
            <div className="flex items-center gap-2 ml-2">
              <DropDownElement logOut={logOut} />
            </div>
          </div>
          <ul className="hidden gap-8 lg:flex">
            <li>
              <div
                onClick={() => {
                  if (enteredUser !== undefined || enteredUser !== null) {
                    navigate("/fa/user-auth");
                  } else {
                    setIsLoginOpen(true);
                  }
                }}
                aria-current="page"
                style={{ cursor: "pointer" }}
                className="block py-2 text-Title/16/Regular rounded  lg:bg-transparent text-gray-700  "
              >
                درخواست اعتبار
              </div>
            </li>
            <li>
              <a
                href="/shops"
                className="block py-2 text-Title/16/Regular rounded  lg:bg-transparent text-gray-700  "
                aria-current="page"
              >
                فروشگاه‌ها
              </a>
            </li>
            <li>
              <a
                href="/cooperation"
                className="block py-2 text-Title/16/Regular rounded  lg:bg-transparent text-gray-700  "
                aria-current="page"
              >
                درخواست همکاری
              </a>
            </li>
            <li>
              <a
                href="/blogs"
                className="block py-2 text-Title/16/Regular rounded  lg:bg-transparent text-gray-700  "
                aria-current="page"
              >
                بلاگ‌ها
              </a>
            </li>
          </ul>
          {isModalOpen &&
            (enteredUser === undefined || enteredUser === null) && (
              <ModalComponents
                setEnteredUser={setEnteredUser}
                onClose={() => setIsModalOpen(false)}
                navigateHere="/fa/seller-auth"
              />
            )}

          {isLoginOpen && (
            <ModalComponents
              onClose={() => setIsLoginOpen(false)}
              setEnteredUser={setEnteredUser}
            /> //ورود
          )}
        </div>
      </header>
    </>
  );
};

export default HeaderLandignUserPanel;
